<app-header></app-header>

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">404 Error Page</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<div class="section-fullscreen">
    <div class="container">
        <div class="position-middle">
            <div class="row g-4 theme-color-blue">
                <div class="col-12">
                    <h1 class="display-2 fw-bold text-gradient-1 line-height-160">Oops! Page Not Found.</h1>
                    <h5 class="fw-light text-dark-05">The page you're looking for might have been moved, deleted, or
                        never existed.</h5>
                    <a class="button btn-candy button-lg button-rounded m-0" routerLink="/"><i class="fas fa-home"></i><span>Go home page</span></a>
                </div>
            </div><!-- end row -->
        </div><!-- end position-middle -->
    </div><!-- end container -->
</div>